import { useQuery } from '@tanstack/react-query';

import { turnosApi, turnosKeys } from '../turnos.api';

/** Cada cuánto se refresca la vista mientras la actualización automática está activa. */
export const AUTO_REFRESH_MS = 30_000;

interface UseTurnosEnVivoOptions {
  /** `true` = refresca cada 30 s; `false` = sólo al abrir o al pulsar "Actualizar". */
  autoRefresh?: boolean;
}

/**
 * Turnos abiertos en este momento.
 *
 * El consolidado cambia con cada venta, así que se reconsulta periódicamente
 * (sin caché) cuando la actualización automática está activa.
 */
export function useTurnosEnVivo({ autoRefresh = true }: UseTurnosEnVivoOptions = {}) {
  return useQuery({
    queryKey: turnosKeys.enVivo,
    queryFn: ({ signal }) => turnosApi.enVivo(signal),
    staleTime: 0,
    refetchInterval: autoRefresh ? AUTO_REFRESH_MS : false,
    refetchIntervalInBackground: false,
  });
}
